import { render, staticRenderFns } from "./Co2Icon.vue?vue&type=template&id=4e152102&scoped=true"
import script from "./Co2Icon.vue?vue&type=script&lang=js"
export * from "./Co2Icon.vue?vue&type=script&lang=js"
import style0 from "./Co2Icon.vue?vue&type=style&index=0&id=4e152102&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e152102",
  null
  
)

export default component.exports